// happypath
export const NoDuplicateLead = 
    {
        data: {
          leadId: "00Qdq0000057KIVEA2",
          bitacoraId: null,
          quotesResponse: false
        },
        error: false
      }


      export const NoDuplicateLeadAsesorCode = 
      {
          data: {
            leadId: "00Qdq0000057KIVEA2",
            bitacoraId:   "4AS42ZSDD00010A0A1",
            quotesResponse: false
          },
          error: false
        }      


// leadduplicados
export const leadduplicados = {
    data: {

        Politica: "Politica de lead duplicados",
    },
    error: false
}




					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					